<template lang="pug">
  yz-api-dropdown(v-model="modelValue" ref="dropdown" :items="items" :loading="loading" :error="error" :count="totalCount" :page-size="pageSize" :page.sync="currentPage" :multiple="multiple" :chips="chips" :size="size" :placeholder="placeholder || $t('panel.select_panel')" :disabled="disabled" item-text="name" item-value="id" searchable, :required="required", :required-error-message="requiredErrorMessage || $t('panel.please_select_panel')" @opened="fetchPanels" @searched="onSearch" @change="onChange")
</template>

<script>
import { mapGetters, mapActions } from 'vuex'

export default {
  props: {
    value: {
      default: () => []
    },
    multiple: {
      type: Boolean,
      default: false
    },
    chips: {
      type: Boolean,
      default: false
    },
    size: {
      type: String,
      default: 'lg'
    },
    placeholder: {
      type: String,
      default: null
    },
    disabled: {
      type: Boolean,
      default: false
    },
    pageSize: {
      type: Number,
      default: 20
    },
    required: {
      type: Boolean,
      default: false
    },
    requiredErrorMessage: {
      type: String,
      default: null
    }
  },
  data() {
    return {
      items: [],
      loading: false,
      error: false,
      totalCount: 0,
      currentPage: 1,
      searchQuery: ''
    }
  },
  computed: {
    ...mapGetters({
      company: 'getCompany'
    }),
    modelValue: {
      get() {
        return this.value
      },
      set(newValue) {
        this.$emit('input', newValue)
      }
    }
  },
  watch: {
    currentPage() {
      if (this.items.length > 0) {
        this.fetchPanels()
      }
    }
  },
  methods: {
    ...mapActions(['showMessage']),
    async fetchPanels() {
      if (!this.company?.id) {
        await this.showMessage(['error', 'Company information not available'])
        return
      }

      this.loading = true
      this.error = false
      try {
        const params = {
          company: this.company.id,
          page: this.currentPage,
          page_size: this.pageSize
        }

        if (this.searchQuery) {
          params.search = this.searchQuery
        }

        const response = await this.$axios.get('/panels', { params })

        this.items = response.data.results || []
        this.totalCount = response.data.count || 0
      } catch (error) {
        console.error('Error fetching panels:', error)
        await this.showMessage(['error', 'Failed to load panels'])
        this.error = true
        this.items = []
        this.totalCount = 0
      } finally {
        this.loading = false
      }
    },
    onSearch(searchTerm) {
      this.searchQuery = searchTerm
      this.currentPage = 1
      this.fetchPanels()
    },
    onChange(newValue) {
      this.$emit('change', newValue)
    }
  }
}
</script>
